import { CheckCircle2, Circle } from "lucide-react";

export default function PassportCompletion({ completion }) {
  if (!completion) return null;
  return (
    <div className="border border-ec-line bg-white p-6 rounded-sm" data-testid="passport-completion">
      <div className="flex items-baseline justify-between">
        <div className="eyebrow">Passport completion</div>
        <span className="font-mono-plex text-xs text-ec-ink-soft">{completion.items.filter(i => i.done).length}/{completion.items.length} done</span>
      </div>
      <div className="font-display text-5xl font-black mt-2 tracking-tighter" data-testid="completion-percent">
        {completion.percent}%
      </div>
      <div className="mt-3 h-2 bg-ec-mute overflow-hidden">
        <div
          className="h-full bg-ec-emerald transition-all duration-700"
          style={{ width: `${completion.percent}%` }}
        />
      </div>
      <ul className="mt-5 grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2 text-sm">
        {completion.items.map((it) => (
          <li key={it.label} className="flex items-center gap-2">
            {it.done ? (
              <CheckCircle2 className="w-4 h-4 text-ec-emerald" />
            ) : (
              <Circle className="w-4 h-4 text-ec-ink-soft" />
            )}
            <span className={it.done ? "line-through text-ec-ink-soft" : ""}>{it.label}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
